import * as React from 'react';
import { ArticleParagraph1 } from '@cian/ui-kit';

import { ESalesType } from '../../types/offersData';

import * as styles from './SalesDescription.css';
import { SALES_TYPE_IMAGES } from '../../constants/salesTypeImages';

interface ISalesLinkProps {
  text: string[];
  type: ESalesType;
}

export function SalesDescription({ type, text }: ISalesLinkProps) {
  const iconSource = SALES_TYPE_IMAGES.get(type);

  return (
    <div className={styles['container']}>
      {iconSource && <img className={styles['icon']} src={iconSource} alt="" />}
      <div className={styles['content']}>
        <ArticleParagraph1>
          {text.map((content, idx) => {
            if (idx < text.length - 1) {
              return [content, <br key={idx} />];
            }

            return content;
          })}
        </ArticleParagraph1>
      </div>
    </div>
  );
}
